<script setup lang="ts">
import getLightness from "~/utils/get-lightness";

export interface CardPlayerHighlightProps {
  imageUrl: string;
  playerNumber: number;
  playerColor: string;
  teamLogo?: string;
  teamTitle?: string;
  isPlaying?: boolean;
  isActive?: boolean;
}

const props = withDefaults(defineProps<CardPlayerHighlightProps>(), {
  isPlaying: false,
  isActive: false,
});

const numberColor = computed(() => {
  const lightness = getLightness(props.playerColor);
  return lightness > 50 ? "#1A1C1E" : "#FFFFFF";
},
);
</script>

<template>
  <div class="flex overflow-hidden w-full relative rounded flex-col" :class="{ 'border border-[var(--base-error-color)]': isActive }">
    <div class="flex relative">
      <div class="absolute flex items-center justify-center w-full h-full z-20 bg-black/40">
        <IconTshirt :fill="props.playerColor" :width="40" :height="40" />
        <div class="absolute text-xs font-bold">
          <span
            :style="{ color: numberColor }"
          >{{ props.playerNumber }}</span>
        </div>
      </div>
      <BaseImage :src="props.imageUrl" :alt="props.imageUrl" class="aspect-video blur-[0.7px]" width="full" height="auto" />
    </div>

    <div class="w-full bg-[var(--base-category-chip-bgColor)] h-[29px] px-2 flex items-center">
      <div class="flex items-center w-full justify-between">
        <div class="font-medium text-base">
          #{{ props.playerNumber }}
        </div>
        <IconEqualizer v-if="props.isPlaying" />
      </div>
    </div>
  </div>
</template>
